import type { TOC } from '@ember/component/template-only';
import { PrismBreadcrumb } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsPageTemplate from 'lumen/components/settings/page-template';

interface MarketSettingsPropertyTagsCustomSignature {
  Args: {};
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.property_tags.custom_tags.description"}}
    @isFullHeight={{true}}
    @title={{t "settings.property_tags.custom_tags.title"}}
  >
    <:breadcrumb>
      <PrismBreadcrumb as |B|>
        <B.item
          @label={{t "settings.property_tags.title"}}
          @route="market.settings.property-tags.index"
        />
        <B.item
          @isCurrent={{true}}
          @label={{t "settings.property_tags.custom_tags.title"}}
        />
      </PrismBreadcrumb>
    </:breadcrumb>
    <:default>
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<MarketSettingsPropertyTagsCustomSignature>;
